<template>
  <div class="qualification-page">
    <div class="title">我的资质</div>
    <div class="qualification-content">
      <div class="tips">温馨提示：如果需要修改资质信息，请前往APP端完成修改</div>
      <div class="file-box">
        <div class="item" v-for="(item, index) in fileList" :key="index">
          <div v-if="item.fileDTOList[0] && item.fileDTOList[0].fileUrl" class="images">
            <el-image
              v-if="item.fileDTOList[0] && item.fileDTOList[0].fileUrl"
              style="width: 200px; height: 200px"
              :src="item.fileDTOList[0].fileUrl"
              :preview-src-list="getUrlList(item.fileDTOList)"
            ></el-image>
          </div>
          <div v-if="item.fileDTOList[0] && item.fileDTOList[0].fileUrl" class="name">{{ item.quaName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
export default {
  created() {
    this.getQualficationInfo();
  },
  methods: {
    async getQualficationInfo() {
      // const data = await api.personal.getAllQualifies();
      // 配合技改 - 2022.11.24
      const data = await api.personal.getCustomerWithExtByStoreId()
      this.fileList = data.customerExt.customerQualifiesInfo;
    },
    getUrlList(img) {
      return img.map(item => item.fileUrl);
    }
  },
  data() {
    return {
      fileList: []
    };
  }
};
</script>

<style lang="scss" scoped>
.qualification-page {
  min-height: 539px;
  background-color: #ffffff;
  .title {
    padding-left: 24px;
    height: 42px;
    border-bottom: 1px solid #eeeeee;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .qualification-content {
    padding: 16px;
    .tips {
      height: 46px;
      background: #f6f9ea;
      font-size: 14px;
      font-weight: 400;
      color: #d8690b;
      line-height: 46px;
      padding-left: 16px;
      margin-bottom: 16px;
    }
    .file-box {
      display: flex;
      flex-wrap: wrap;
      padding-left: 46px;
      .item {
        margin-bottom: 24px;
      }
      .images {
        width: 200px;
        height: 200px;
        background: #ffffff;
        border: 1px solid #f5f5f5;
        margin-right: 24px;
        margin-bottom: 24px;
        img {
          width: 200px;
          height: 200px;
          margin: auto;
        }
      }
      .name {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        color: #595959;
        text-align: center;
        line-height: 17px;
        width: 200px;
      }
    }
  }
}
</style>
